module.exports = __webpack_public_path__ + "static/media/crown.c17d8cbe.svg";